import type {SubAgent} from '../types/agent'
import {fetchCAPI} from '../utils/fetch-capi'
import {useCAPIQuery} from './useCAPIQuery'
import type {DropdownRepository} from './useCopilotRepoFetching'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export function useSubAgents({repo}: {repo: DropdownRepository}) {
  const shouldRetryOn401 = isFeatureEnabled('agent_session_retry_fetch_capi_on_401')
  const query = useCAPIQuery<SubAgent[]>({
    queryKey: ['custom-agents', repo.owner, repo.nameOnly],
    queryFn: async () => {
      try {
        const response = await fetchCAPI({
          path: `/agents/swe/custom-agents/${repo.owner}/${repo.nameOnly}`,
          retryOn401: shouldRetryOn401,
        })

        if (response.status === 404) {
          return []
        }

        const data = await response.json()
        const agents = data.agents as SubAgent[]

        return agents
      } catch {
        return []
      }
    },
  })

  return query
}
